<button class="mobile-saldeo-button" (click)="navigateToSaldeo($event)">
  <div class="saldeo-content">
    <span class="saldeo-label">{{ label | translate }}</span>
  </div>
</button>